// Register global mixins, components and plugins only once, otherwise we can create memory leaks
// https://github.com/vuejs/vue/issues/5089#issuecomment-284260111
import Vue from 'vue';

// Plugins
import VueCookies from 'vue-cookies';
import FocusLock from '@components/FocusLock';
import VueSocialSharing from 'vue-social-sharing';

import GmapVue from 'gmap-vue';

// Components
import MrIcon from '@components/MrIcon';
import imgBox from '@components/imgBox';
import CmsExposeSettings from '@components/CmsExposeSettings';
import party from '@components/party';
import toggle from '@components/toggle';
import slick from '@components/SlickCarouselSsr';
import ResponsiveImage from '@components/ResponsiveImage';
import AddPromo from '@components/AddPromo';
import MrSpinnerVeil from '@components/MrSpinnerVeil';
import TransitionExpand from '@components/TransitionExpand';
import { VueSvgIconPlugin } from '@yzfe/vue-svgicon';

// Mixins
import globalMixins from '@mixins/globalMixins';

// Filters
import filters from "../filters";
import filtersPlugin from '../plugins/filtersPlugin.js';

// Directives
import mrScrollAnimation from "../directives/mrScrollAnimation";
import clickOutside from "../directives/clickOutside";
import vRipple from "../directives/vRipple";

const stars = () => import(/* webpackChunkName: 'stars' */ '@components/stars');
const toggleHeight = () => import(/* webpackChunkName: 'toggleHeight' */ '@components/toggleHeight');
const MultiSelectDropdown = () => import(/* webpackChunkName: 'MultiSelectDropdown' */ '@components/MultiSelectDropdown');
const CmsPartial = () => import(/* webpackChunkName: 'CMSPartial' */ '@components/CMSPartial');
const SierraStartChatBtn = () => import(/* webpackChunkName: 'SierraStartChatBtn' */ '@components/SierraStartChatBtn');


// Flag for avoiding to re-inject all of these "Vue.X" methods into the same Vue instance, creating a memory leak
// https://github.com/vuejs/vue/issues/5089#issuecomment-284260111
if (!Vue.globalsSsrRegistered) {
  Vue.globalsSsrRegistered = true;

  Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
  });

  Vue.use(filtersPlugin);

  Vue.use(VueCookies);
  Vue.use(VueSocialSharing);

  Vue.use(GmapVue, {
    // [OPTIONAL] If you intend to programmatically custom event listener code
    // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    // you might need to turn this on.
    autoBindAllEvents: true,

    // [OPTIONAL] If you want to manually install components, e.g.
    // import {GmapMarker} from 'gmap-vue/src/components/marker'
    // Vue.component('GmapMarker', GmapMarker)
    // then set installComponents to 'false'.
    // If you want to automatically install all the components this property must be set to 'true':
    installComponents: false,

    // Load the Google Maps API dynamically, if you set this to `true` the plugin doesn't load the Google Maps API
    dynamicLoad: true,
  });

  Vue.mixin(globalMixins);

  Vue.component('focus-lock', FocusLock);
  Vue.component('mr-icon', MrIcon);
  Vue.component('img-box', imgBox);
  Vue.component('cms-expose-settings', CmsExposeSettings);
  Vue.component('party', party);
  Vue.component('toggle', toggle);
  Vue.component('slick', slick);
  Vue.component('responsive-image', ResponsiveImage);
  Vue.component('AddPromo', AddPromo);
  Vue.component('MrSpinnerVeil', MrSpinnerVeil);
  Vue.component('TransitionExpand', TransitionExpand);
  Vue.component('Stars', stars);
  Vue.component('ToggleHeight', toggleHeight);
  Vue.component('MultiSelectDropdown', MultiSelectDropdown);
  Vue.component('CmsPartial', CmsPartial);
  Vue.component('SierraStartChatBtn', SierraStartChatBtn);

  Vue.directive('mrscrollanimation', mrScrollAnimation);
  Vue.directive('click-outside', clickOutside);
  Vue.directive('ripple', vRipple);

  // We install `vue-svgicon` as plugin
  // and configure it to prefix all CSS
  // classes with `mr-icon-`.
  Vue.use(VueSvgIconPlugin, {
    tagName: 'svgicon',
    classPrefix: 'mr'
  });

}
